var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "contact" }, [
    _c("div", { staticClass: "root" }, [
      _c("h1", [_vm._v(_vm._s(_vm.$t("contact.title")))]),
      _vm.activeNotice
        ? _c("div", { staticClass: "notice-box" }, [
            _c("p", { staticClass: "notice-title" }, [
              _vm._v(_vm._s(_vm.$t(_vm.activeNotice.titleKey))),
            ]),
            _c("p", { staticClass: "notice-message" }, [
              _vm._v(_vm._s(_vm.$t(_vm.activeNotice.messageKey))),
            ]),
          ])
        : _vm._e(),
      _c("p", { staticClass: "contact-message" }, [
        _vm._v(" " + _vm._s(_vm.$t("contact.thankYou"))),
        _c("br"),
        _c("br"),
        _c("span", { staticClass: "contact-message-title" }, [
          _vm._v(_vm._s(_vm.$t("contact.beforeContact.title"))),
        ]),
        _c("br"),
        _vm._v(
          " " + _vm._s(_vm.$t("contact.beforeContact.helpPageDescription"))
        ),
        _c("br"),
        _vm._v(" " + _vm._s(_vm.$t("contact.beforeContact.checkHelpPage"))),
        _c(
          "a",
          {
            staticClass: "bold",
            attrs: {
              href: _vm.help,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v(_vm._s(_vm.$t("contact.beforeContact.helpPageLink")))]
        ),
        _vm._v(_vm._s(_vm.$t("contact.beforeContact.checkHelpPageSuffix"))),
        _c("br"),
        _c("br"),
        _vm._v(" " + _vm._s(_vm.$t("contact.beforeContact.stillNotResolved"))),
        _c("br"),
        _c("br"),
        _c("b", [
          _vm._v(
            _vm._s(_vm.$t("contact.inquiryGuidelines.questionOrBugTitle"))
          ),
        ]),
        _c("br"),
        _vm._v(
          " " +
            _vm._s(_vm.$t("contact.inquiryGuidelines.requireInvestigationInfo"))
        ),
        _c("br"),
        _vm._v(" " + _vm._s(_vm.$t("contact.inquiryGuidelines.delayWarning"))),
        _c("br"),
        _c("br"),
        _c("b", [
          _vm._v(_vm._s(_vm.$t("contact.inquiryGuidelines.requestTitle"))),
        ]),
        _c("br"),
        _vm._v(
          " " + _vm._s(_vm.$t("contact.inquiryGuidelines.requestReference"))
        ),
        _c("br"),
        _vm._v(
          " " + _vm._s(_vm.$t("contact.inquiryGuidelines.requestForm.prefix"))
        ),
        _c(
          "a",
          {
            staticClass: "bold",
            attrs: {
              href: _vm.requestFormUrl,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v(_vm._s(_vm.$t("contact.inquiryGuidelines.requestForm.link")))]
        ),
        _vm._v(_vm._s(_vm.$t("contact.inquiryGuidelines.requestForm.suffix"))),
        _c("br"),
        _vm._v(
          " " + _vm._s(_vm.$t("contact.inquiryGuidelines.noReplyToRequest"))
        ),
        _c("br"),
        _vm._v(
          " " + _vm._s(_vm.$t("contact.inquiryGuidelines.checkHelp.prefix"))
        ),
        _c(
          "a",
          {
            staticClass: "bold",
            attrs: {
              href: _vm.help,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v(_vm._s(_vm.$t("contact.inquiryGuidelines.checkHelp.link")))]
        ),
        _vm._v(
          _vm._s(_vm.$t("contact.inquiryGuidelines.checkHelp.suffix")) + " "
        ),
      ]),
      _c("a", { staticClass: "button email", attrs: { href: _vm.mail } }, [
        _c("img", {
          attrs: { src: require("@/assets/img/static/sns-icon-mail.png") },
        }),
        _c("div", { staticClass: "email-txt" }, [
          _vm._v(_vm._s(_vm.$t("contact.sendByEmail"))),
        ]),
      ]),
      _c("div", { staticClass: "fallback-link" }, [
        _c(
          "button",
          {
            staticClass: "link-button",
            on: { click: _vm.showFallbackOptions },
          },
          [
            _vm._v(
              " " + _vm._s(_vm.$t("contact.mailerFallback.linkText")) + " "
            ),
          ]
        ),
      ]),
      _vm.showFallback
        ? _c("div", { staticClass: "fallback-section" }, [
            _c("h3", [_vm._v(_vm._s(_vm.$t("contact.mailerFallback.title")))]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("contact.mailerFallback.description"))),
            ]),
            _c("div", { staticClass: "fallback-info" }, [
              _c("div", { staticClass: "info-item" }, [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("contact.mailerFallback.to"))),
                ]),
                _c("div", { staticClass: "input-row" }, [
                  _c("input", {
                    ref: "mailToInput",
                    staticClass: "copy-input",
                    attrs: { type: "text", readonly: "" },
                    domProps: { value: _vm.mailTo },
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "copy-btn",
                      on: { click: () => _vm.copyToClipboard("mailTo") },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("contact.mailerFallback.copy")) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-item" }, [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("contact.mailerFallback.subject"))),
                ]),
                _c("div", { staticClass: "input-row" }, [
                  _c("input", {
                    ref: "subjectInput",
                    staticClass: "copy-input",
                    attrs: { type: "text", readonly: "" },
                    domProps: { value: _vm.mailSubject },
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "copy-btn",
                      on: { click: () => _vm.copyToClipboard("subject") },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("contact.mailerFallback.copy")) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-item" }, [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("contact.mailerFallback.body"))),
                ]),
                _c("div", { staticClass: "input-row" }, [
                  _c("textarea", {
                    ref: "bodyTextarea",
                    staticClass: "copy-textarea",
                    attrs: { readonly: "" },
                    domProps: { value: _vm.mailBody },
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "copy-btn",
                      on: { click: () => _vm.copyToClipboard("body") },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("contact.mailerFallback.copy")) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "action-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "copy-all-btn",
                  on: { click: _vm.copyAllMailInfo },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("contact.mailerFallback.copyAll")) + " "
                  ),
                ]
              ),
              _c(
                "button",
                { staticClass: "close-btn", on: { click: _vm.hideFallback } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("contact.mailerFallback.close")) + " "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _c("p", [
        _vm._v(" " + _vm._s(_vm.$t("contact.faqSection.prefix")) + " "),
        _c(
          "a",
          {
            staticClass: "bold",
            attrs: {
              href: _vm.help,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v(_vm._s(_vm.$t("contact.faqSection.linkText")))]
        ),
        _vm._v(" " + _vm._s(_vm.$t("contact.faqSection.suffix1"))),
        _c("br"),
        _vm._v(" " + _vm._s(_vm.$t("contact.faqSection.suffix2")) + " "),
      ]),
      _c("h2", [_vm._v(_vm._s(_vm.$t("contact.investigationInfo.title")))]),
      _c("textarea", {
        ref: "textarea",
        attrs: { type: "text", readonly: "" },
        domProps: { value: _vm.diagInfo },
      }),
      _c(
        "button",
        {
          staticClass: "button-copy",
          on: { click: () => _vm.copyToClipboard() },
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("contact.investigationInfo.copyButton")) + " "
          ),
        ]
      ),
      _vm.message
        ? _c("div", { staticClass: "info" }, [_vm._v(_vm._s(_vm.message))])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }